import isURL from 'validator/lib/isURL'
import * as yup from 'yup'

import { NAME_MAX_LENGTH, URL_MAX_LENGTH } from '@/constants'
import { TTranslationFunction } from '@/types'

export const urlSchema = (
	t: TTranslationFunction,
	{
		required,
		maxLength = URL_MAX_LENGTH,
	}: {
		required: boolean
		maxLength?: number
	},
) => {
	let schema = yup.string().trim()

	if (required) {
		schema = schema.required(
			t('ui__field_validation_errors__generic__required'),
		)
	}

	schema = schema
		.max(
			maxLength,
			t('ui__field_validation_errors__generic__max_length', {
				length: maxLength,
			}),
		)
		.test(
			'is-url',
			t('ui__field_validation_errors__url__generic'),
			(value) => !value || isURL(value),
		)

	return schema
}

export const nameSchema = (
	t: TTranslationFunction,
	{
		required,
		maxLength = NAME_MAX_LENGTH,
	}: {
		required: boolean
		maxLength?: number
	},
) => {
	let schema = yup.string().trim()

	if (required) {
		schema = schema.required(
			t('ui__field_validation_errors__generic__required'),
		)
	}

	schema = schema.test('name-validation', function (value) {
		const { path, createError } = this

		if (!value) return !required

		if (value.length > maxLength) {
			return createError({
				path,
				message: t('ui__field_validation_errors__generic__max_length', {
					length: maxLength,
				}),
			})
		}

		return true
	})

	return schema
}
